module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/298e234a90ef1161c01bdeeb833fa142.png";